
window.ApiHost1 = 'http://47.107.120.133/LYPYWEBAPI';   //http://172.16.69.65/3DWEBAPI/
window.ApiHost2 = 'http://172.16.69.65:8083';   //http://172.16.22.42:8083    http://192.168.101.178:8086
window.CurrentTheme = 'theme-blue';  //默认主题
window.PYKWareHouseCode = '1103619506519019520';
window.PYKScadaCode = 'PFK';
window.PYKScadaCode1 = 'S7-200'; 


// WEBPACK FOOTER //
// ./src/components/xiayan/config.js